import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        else if (to.hash) return { selector: to.hash }
        else if (from.path === to.path) return {}

        return {
            top: 1,
            behavior: 'smooth'
        }
    },
    routes: [
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/User/Users.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/projects',
            name: 'projects',
            component: () => import('@/views/Project/Projects.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: `/projects/:id`,
            name: 'project',
            component: () => import('@/views/Project/Project.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/allowed-outbound-emails',
            name: 'allowed-outbound-emails',
            component: () => import('@/views/AllowedOutboundEmail/AllowedOutboundEmails.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/smtp-providers',
            name: 'smtp-providers',
            component: () => import('@/views/SMTPProvider/SMTPProviders.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/',
            name: 'emails',
            component: () => import('@/views/Emails/Emails.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
})

router.beforeEach((to, from, next) => {
    const loggedIn: boolean = isAuthenticated()
    const appStore = useAppStore()

    if (loggedIn && to.name === 'login') {
        next({ name: 'emails' })
        return
    }

    if (to.meta.requiresAuth && !isAuthenticated()) {
        appStore.setLogout()
        next({ name: 'login' })
    }

    next()
})

export default router
